import { useNavigate } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux"
import { faPenToSquare } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { resetMenuMaster } from "../../state/menuMasterSlice.js"
import { apiRoute, linksUrl } from "../../constants/enum.js"
import { useFetchWithBody } from "../../api/reactQueryCustomHooks.jsx"
import { ErrorCard, LoadingCard, MainContainer, NextUITable } from "../../components/index.js"
import { COLUMN_TYPE } from "../../components/NextUITable.jsx"

function UserMenuMapping() {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { appClientMapping } = useSelector((state) => state.appClientMapping)
  const { selectedUser } = useSelector((state) => state.userMaster)
  const { selectedClient } = useSelector((state) => state.clientMaster)

  const exportColumns = [
    { uid: "Client_Code", name: "Client Code" },
    { uid: "UserId", name: "User Id" },
    { uid: "MenuId", name: "Menu Id" },
    { uid: "MenuName", name: "Menu Name" },
    { uid: "MenuParentId", name: "Menu Parent Id" },
    { uid: "Level", name: "Level" },
  ]

  const onClickPrevPage = () => {
    dispatch(resetMenuMaster())
    navigate(linksUrl.userMaster.read)
  }

  const {
    isLoading,
    isError,
    data = [],
  } = useFetchWithBody({
    url: apiRoute.userMenuMapping.read,
    queryKey: "UserMenuMapping",
    inputData: {
      userId: selectedUser.UserId,
      option: 1,
    },
  })

  const columns = [
    { uid: "Level", name: "Level", type: COLUMN_TYPE.chip },
    { uid: "MenuName", name: "Menu Name" },
  ]

  const INITIAL_VISIBLE_COLUMNS = ["Level", "MenuName"]

  const topActionBtn = [
    {
      icon: <FontAwesomeIcon icon={faPenToSquare} />,
      onClick: () => {
        navigate(linksUrl.userMenuMapping.edit)
      },
      label: "Edit Menu", 
    },
  ]

  
 

  if (isLoading) {
    return <LoadingCard />
  }

  if (isError) {
    return <ErrorCard />
  }

  return (
    <div>
      <MainContainer
        pageName="User Menu Mapping"
        breadcrumbs={["Client Master", "User Master", "Menu"]}
        info={[
          ["Client", selectedClient.client_name, selectedClient.client_code],
          ["User", selectedUser.LoginName],
          ["App", appClientMapping && appClientMapping.map((item) => item.AppName)],
        ]}
        prevPage={{
          show: true,
          onClick: onClickPrevPage,
        }}
      >
        <NextUITable
          INITIAL_VISIBLE_COLUMNS={INITIAL_VISIBLE_COLUMNS}
          data={data}
          columns={columns}
          exportColumns={exportColumns}
          topActionBtn={topActionBtn}
          
          
          downloadFileName="User_Menu_Mapping"
          id="MenuId"
        />
      </MainContainer>
    </div>
  )
}

export default UserMenuMapping
